import React, { ReactElement, useEffect, useState } from 'react';
import './PanelCollapse.less';
import Collapse, { CollapseProps } from 'antd/lib/collapse';
import { GUTTOR_SPACE } from '../../constants/commonConstants';

const PanelCollapse = (props: CollapseProps | any): ReactElement => {
  const { Panel } = Collapse;
  const { fontSizeClassName } = props;
  const [customProps, setCustomProps] = useState(props);
  useEffect((): any => {  // to enable panel collpase open or not
    if (props?.activeKey === undefined) {
      setCustomProps((prev: any): any => {
        const { activeKey, ...rest } = props;
        return rest;
      });
    } else {
      setCustomProps(props);
    }
  }, [props]);
  return (
    <div className={fontSizeClassName ? `panel-collpase ${fontSizeClassName}` : 'panel-collpase'}>
      <Collapse className="ant-collapse-icon-position-right" {...customProps}
        style={{ marginBottom: GUTTOR_SPACE }}
      >
        <Panel header={props.header} key={props.keyName}>
          {props.children}
        </Panel>
      </Collapse>
    </div>
  );
};

export default PanelCollapse;
